import { DataBean } from "../../DataBean";


export class HealthScopeSupport extends DataBean {

    public async getHealthScopeSupportCatalog(idHealthScope: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthScopeSupportCatalog_Number_String_Number_Number", [idHealthScope, regexStr, page, recordsPerPage]);
    }

    public async addHealthScopeSupport(idHealthScope: any, idLnHealthID: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.health.HealthScopeSupport_addHealthScopeSupport_Number_Number", [idHealthScope, idLnHealthID]);
    }

}